/**
 * Display-only entity / role terminology (Partnership review 9/1/26, UI-07).
 * Do not use for API payloads, Salesforce field names, or filter values —
 * those keep existing codes (ll, pm, building_id, etc.).
 */

export const ROLE_DISPLAY_LABELS = {
  admin: 'Admin',
  ll: 'Operator',
  vp: 'Full Portfolio',
  rm: 'Multi-Site',
  pm: 'Property Manager',
};

/** Dashboard user-count tiles — "… User Count" (LLP-181). */
export const ROLE_USER_COUNT_TILE_LABELS = {
  ll: 'Total Operator User Count',
  vp: 'Total Full Portfolio User Count',
  rm: 'Total Multi-Site User Count',
  pm: 'Total Property User Count',
};

export const ENTITY_DISPLAY_LABELS = {
  building: 'Property',
  buildings: 'Properties',
  company: 'Operator',
  companies: 'Operators',
  companyInvite: 'Operator Invite',
  companyName: 'Operator Name',
  searchBuilding: 'Search Property',
  searchCompany: 'Search Operator',
  /** Column / filter label for property totals (LLP-181). */
  numOfBuilding: 'Property Count',
  propertyCount: 'Property Count',
  unitCount: 'Unit Count',
  residentialBuildings: 'Residential Properties',
  /** Sidebar parent of Properties / Applications / Policies / Claims */
  portfolioNav: 'Portfolio',
};

export function roleLabelForDisplay(roleCode) {
  if (roleCode == null || roleCode === '') return roleCode;
  return ROLE_DISPLAY_LABELS[roleCode] || roleCode;
}

export function roleUserCountTileLabel(roleCode) {
  return ROLE_USER_COUNT_TILE_LABELS[roleCode] || roleLabelForDisplay(roleCode);
}

/**
 * Replace common entity terms in free-form UI copy.
 * Prefer ROLE_DISPLAY_LABELS / ENTITY_DISPLAY_LABELS for known keys.
 */
export function replaceEntityTermsInCopy(text) {
  if (text == null || text === '') return text;
  let next = String(text);
  next = next.replace(/\bCompany Invite\b/g, ENTITY_DISPLAY_LABELS.companyInvite);
  next = next.replace(/\bCompany Name\b/g, ENTITY_DISPLAY_LABELS.companyName);
  next = next.replace(/\bSearch Building\b/gi, ENTITY_DISPLAY_LABELS.searchBuilding);
  next = next.replace(/\bSearch Company\b/gi, ENTITY_DISPLAY_LABELS.searchCompany);
  next = next.replace(
    /\bNum(?:\.|ber)? of Building(?:s)?\b/gi,
    ENTITY_DISPLAY_LABELS.numOfBuilding,
  );
  next = next.replace(/\bNumber of Properties\b/gi, ENTITY_DISPLAY_LABELS.propertyCount);
  // Invitations list used "# Properties" (LLP-181); keep helper aligned with column rename.
  next = next.replace(/#\s*Properties\b/gi, ENTITY_DISPLAY_LABELS.propertyCount);
  next = next.replace(/\bNumber of Units\b/gi, ENTITY_DISPLAY_LABELS.unitCount);
  next = next.replace(/\bResidential Buildings\b/g, ENTITY_DISPLAY_LABELS.residentialBuildings);
  next = next.replace(/\bTotal Companies\b/g, 'Total Operators');
  next = next.replace(/\bCompanies\b/g, ENTITY_DISPLAY_LABELS.companies);
  next = next.replace(/\bCompany\b/g, ENTITY_DISPLAY_LABELS.company);
  next = next.replace(/\bBuildings\b/g, ENTITY_DISPLAY_LABELS.buildings);
  next = next.replace(/\bBuilding\b/g, ENTITY_DISPLAY_LABELS.building);
  return next;
}
